import type { CompoundSupplyRecord } from "@/utils/types/supply";

// Empty stubs preserved because three call sites (computeCost, batchTarget,
// replacementReasons, FlaskRow/FlaskBar imports) still read these via the
// barrel. The objects always return undefined per key — the runtime UI
// degrades silently to "no supply data" everywhere. Real supply data is
// expected to come from a future server endpoint.
export const COMPOUND_SUPPLY: Record<string, CompoundSupplyRecord> = {};
